import { motion } from "framer-motion";
import { offer, whatsappPrefill } from "@/config/site";
import { Section } from "./Section";
import { Reveal, EASE } from "./Reveal";

const STEPS = [
    { n: "01", t: "Inspect", d: "Every car begins with a walk-around and an honest condition assessment." },
    { n: "02", t: "Consult", d: "We discuss goals, options and what your vehicle actually needs." },
    { n: "03", t: "Prepare", d: "Wash, decontamination and masking set the foundation for clean work." },
    { n: "04", t: "Craft", d: "Correction, film, coating or custom work — executed by trained hands." },
    { n: "05", t: "Protect", d: "Finishing layers and protection lock in the result for the road ahead." },
    { n: "06", t: "Reveal", d: "Final inspection and a handover walked through with you, detail by detail." },
];

export const Process = () => (
    <Section id="process" index="11" label="Process" title="How your car moves through Revautoz." alt>
        <div className="mt-14">
            <motion.div
                aria-hidden="true"
                initial={{ scaleX: 0 }}
                whileInView={{ scaleX: 1 }}
                viewport={{ once: true, margin: "-15%" }}
                transition={{ duration: 1.4, ease: EASE }}
                className="mb-6 h-px w-full origin-left bg-gradient-to-r from-rz-red via-rz-red/40 to-transparent"
            />
            <ol className="grid gap-px border border-rz-steel/60 bg-rz-steel/60 sm:grid-cols-2 lg:grid-cols-6">
            {STEPS.map((s, i) => (
                <Reveal
                    key={s.n}
                    as="li"
                    delay={i * 0.06}
                    className="group relative bg-rz-carbon p-6 lg:p-6"
                >
                    <span className="absolute left-6 top-0 h-[2px] w-8 bg-rz-red transition-[width] duration-500 group-hover:w-14" />
                    <span className="font-display text-[12px] font-semibold tracking-[0.25em] text-rz-red">
                        {s.n}
                    </span>
                    <h3 className="mt-6 font-display text-lg font-bold uppercase tracking-wide text-rz-white">
                        {s.t}
                    </h3>
                    <p className="mt-3 text-[13px] leading-relaxed text-rz-smoke">{s.d}</p>
                </Reveal>
            ))}
            </ol>
            <Reveal className="mt-8" delay={0.15}>
                <a
                    data-testid="process-inspection-cta"
                    href={whatsappPrefill(offer.message)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 font-display text-[12px] font-semibold uppercase tracking-[0.2em] text-rz-red transition-transform duration-300 hover:translate-x-1"
                >
                    Every journey starts with a free inspection →
                </a>
            </Reveal>
        </div>
    </Section>
);
